module.exports = __webpack_public_path__ + "static/media/41.2411e8a9.png";